import React, { useEffect, useState } from 'react';
import { fetchItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';
import Pagination from '../../../../../components/Pagination';
import { usePagination } from '../../../../../hooks/usePagination';
import BlogCard from './BlogCard';
import { UiBlog } from '../../../../../api/types';
import { Link } from 'react-router-dom';
import { fileUrl } from '../../../../../api/config';
import { getRelativeTime } from '../../../../../api/callApi';

export default function RealisationList() {

    const [listData, setDataList] = useState<UiBlog[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(4);
    const [totalPages, setTotalPages] = useState(1);

    const { paginationRange, isCurrentPage, isFirstPage, isLastPage } = usePagination({
        currentPage,
        totalPages,
    });

    const loadlistData = async () => {
        setLoading(true);
        try {
            const res = await fetchItems<UiBlog>('/fetch_realisation', {
                q: search,
                page: currentPage,
                limit,
            });

            setDataList(res.data);
            setTotalPages(res.totalPages);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.title = "Nos réalisations - Ouragan Academy";
        loadlistData();
    }, [search, currentPage]);

    return (
        <div className="container py-4">

            {/* HEADER */}
            <div className="text-center mb-5">
                <h2 className="display-10 fw-bold mb-3">
                    Nos <span className="text-primary">Réalisations</span>
                </h2>
                <p className="lead text-muted">
                    Découvrez les activités, projets et moments marquants qui façonnent l'Ouragan Academy.
                </p>
            </div>

            {/* 🔍 SEARCH */}
            <div className="row justify-content-center mb-4">
                <div className="col-lg-12">
                    <div className="input-group shadow-sm rounded-pill overflow-hidden">
                        <span className="input-group-text bg-white border-0 ps-4">
                            <i className="fas fa-search text-primary"></i>
                        </span>

                        <input className="form-control border-0 rounded-pill-start py-3 px-4"
                            placeholder="Rechercher une réalisation, un événement ou une histoire..." type="text"
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setCurrentPage(1);
                            }}

                        />
                        <button className="btn btn-primary rounded-pill-end px-4" type="button" onClick={() => loadlistData()}><i className="fas fa-search"></i></button>
                    </div>
                </div>
            </div>

            {/* LISTE DES ARTICLES */}
            <div className="row g-4">
                {listData.length === 0 ? (
                    <LoaderAndError
                        loading={loading}
                        error={error}
                        onClearError={() => setError(null)}
                    />
                ) : (
                    listData.map((article) => (
                        <div key={article.id} className="col-md-6 col-lg-6">
                            <div
                                className="
                                               project-card shadow-sm rounded-4 border-0 h-100 overflow-hidden bg-white dark:bg-gray-900 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 p-4
                                            "
                                style={{ cursor: "pointer" }}
                            >

                                {/* IMAGE */}
                                <div className="position-relative">
                                    <img
                                        src={`${fileUrl}/images/${article.icone}`}
                                        alt={article.titre}
                                        className="img-fluid w-100"
                                        style={{
                                            height: "220px",
                                            objectFit: "cover"
                                        }}
                                    />

                                    {/* BADGE CATÉGORIE */}
                                    {article.category_blog?.titre && (
                                        <span
                                            className="
                                                            badge bg-primary 
                                                            position-absolute top-0 start-0 
                                                            m-1
                                                            rounded-pill shadow-sm
                                                        "
                                        >
                                            {article.category_blog.titre}
                                        </span>
                                    )}
                                </div>

                                {/* BODY */}
                                <div className="card-body">

                                    {/* DATE */}
                                    <div className="mb-2 text-muted small d-flex align-items-center">
                                        <i className="fas fa-calendar-alt me-2 text-primary"></i>
                                        Publié {getRelativeTime(article.createdAt ?? "")}
                                    </div>

                                    {/* TITRE */}
                                    <h3 className="h5 fw-bold text-dark mb-2 text-truncate-2">
                                        <Link to={`/realisation/${article.slug}`} style={{ textDecoration: "none" }}> {article.titre}</Link>
                                    </h3>

                                    {/* SOUS TITRE */}
                                    <p className="text-muted mb-3 text-truncate-3">
                                        {article.sousTitre}
                                    </p>

                                  
                                </div>



                            </div>
                        </div>
                    ))
                )}

            </div>

            {/* PAGINATION */}
            <div className="text-center mt-5">
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    paginationRange={paginationRange}
                    isCurrentPage={isCurrentPage}
                    isFirstPage={isFirstPage}
                    isLastPage={isLastPage}
                    onPageChange={setCurrentPage}
                    textCounter={true}
                />
            </div>
        </div>
    );
}
